export default __webpack_public_path__ + "static/media/flexseal.d698891e.png";